module.exports = __webpack_public_path__ + "img/relmanager.1b5111ad.png";